import React from "react";
import { iconStyles } from "./iconStyles";
export function PlusIcon() {
    return (<svg className={iconStyles} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <path d="M33 20C33 20.5625 32.5 21 32 21H21V32C21 32.5625 20.5 33.0625 20 33.0625C19.4375 33.0625 19 32.5625 19 32V21H8C7.4375 21 7 20.5625 7 20.0625C7 19.5 7.4375 19 8 19H19V8C19 7.5 19.4375 7.0625 20 7.0625C20.5 7.0625 21 7.5 21 8V19H32C32.5 19 33 19.5 33 20Z"/>
        </svg>);
}
